import * as ActionTypes from './ActionTypes';
import InitialState from './InitialState';
import { assign } from '../../shared/Assign';
import IFeatureState from '../../store/IFeatureState';

export default function productTypeReducer(
    state: any = InitialState.productTypes,
    action: { type: string; result: any }
) {
    let newState: IFeatureState;

    switch (action.type) {
        case ActionTypes.LIST_PRODUCT_TYPES_SUCCESS:
            newState = assign({}, state);
            newState.list = action.result;
            return newState;

        case ActionTypes.NEW_PRODUCT_TYPE_SUCCESS:
            newState = assign({}, state);
            newState.new = { types: [...action.result.types] };
            return newState;

        case ActionTypes.CREATE_PRODUCT_TYPE_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list, assign({}, action.result)];
            return newState;

        case ActionTypes.EDIT_PRODUCT_TYPE_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            newState.edit = assign({}, action.result);
            return newState;

        case ActionTypes.UPDATE_PRODUCT_TYPE_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;

        case ActionTypes.DELETE_PRODUCT_TYPE_SUCCESS:
            newState = assign({}, state);
            newState.list = [...state.list.filter((x: any) => x.id !== action.result)];
            return newState;

        default:
            return state;
    }
}
